import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura G.',
    role: 'Mamá de un niño de 4 años',
    text: '¡Me salvó las tardes! Mi hijo pasaba mucho tiempo con la tablet y yo me sentía culpable. Desde que imprimí estas actividades, se pasa horas pintando y resolviendo los laberintos. Súper recomendado.'
  }, {
    name: 'Martín S.',
    role: 'Papá de mellizas de 5 años',
    text: 'El material es excelente. Lo que más me gusta es que no tengo que pensar qué hacer, simplemente imprimo un par de hojas del tomo que quiero y ya tenemos actividad para la tarde. Las nenas lo disfrutan mucho.'
  }, {
    name: 'Carolina M.',
    role: 'Mamá de un niño de 3 años',
    text: 'Compré el pack hace una semana y ya veo avances en cómo agarra el lápiz. Las actividades de motricidad fina son geniales y muy fáciles de entender. Además, los bonos son un regalo hermoso.'
  }, {
    name: 'Julieta P.',
    role: 'Mamá de una niña de 6 años',
    text: 'Estábamos buscando algo para prepararla para primer grado y el tomo de lectoescritura nos vino perfecto. Aprende jugando y sin frustrarse. La tabla de recompensas nos ayudó un montón con la rutina.'
  }, {
    name: 'Diego R.',
    role: 'Papá de un niño de 4 años',
    text: 'Vale cada centavo. Fui a una librería a buscar libritos similares y me salían el triple por mucha menos cantidad. Acá tengo material para todo el año. Muy buena calidad de los dibujos.'
  }];
  return <section className="w-full py-16 bg-[#F5F7FA]" data-id="element-327">
      <div className="max-w-3xl mx-auto px-4" data-id="element-328">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-329">
          Lo que dicen otros padres...
        </h2>

        <div className="space-y-6" data-id="element-330">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200" data-id="element-331">
              <div className="flex text-yellow-400 mb-3" data-id="element-332">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-333" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-4" data-id="element-334">"{t.text}"</p>
              <div data-id="element-335">
                <p className="font-bold text-gray-900" data-id="element-336">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-337">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}